var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":_vm.openCaptcha}}),(_vm.captchaShow)?_c('RoutateCaptcha',{attrs:{"options":_vm.captchaOptions},on:{"close":function($event){_vm.captchaShow = false},"init":_vm.captchaInit,"complete":_vm.captchaComplete,"success":_vm.captchaSuccess,"fail":_vm.captchaFail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }